/* jslint esversion: 6 */
/**
 * Equalize Height
 *
 * Equalize height across selected elements. Comparison can be done across all
 * selected elements as-a-whole or by matching element offset from the top of
 * the document as if they were in rows.
 *
 * @author Dylan James Wagner
 *
 * @param string          selector    - required - A valid jquery selector.
 * @param boolean|integer conditional - optional - Default true. Boolean or integer representing the viewport min-width in pixels.
 *
 * @todo consider settings.transition true/false
 * @todo consider settings visual debug true/false
 * @todo review conditional logic complexity and general usefulness
 *
 * @usage
 *
 * $(window).on('load resize', function() {
 *     equalizeHeighTop('.cards .card__text', 768);
 * });
 */
const $ = window.jQuery;
const s = {
	transition : false,
	debug      : false,
};

function all(selector, conditional) {
	const $selector = $(selector);
	conditional = typeof conditional !== 'undefined' ? (typeof conditional === 'boolean' ? conditional : (parseFloat($(window).width()) >= conditional ? true : false)) : true;

	if ($selector.length) {
		$selector.css('height', 'auto'); // reset height

		if (conditional) {
			var heights = [];

			// get // set
			$selector.each(function(index) {
				heights[index] = parseFloat($(this).css('height'));
			})
			.css('height', Math.max.apply(Math, heights));

			// visual debug highlight equalized elements
			if (s.debug) {
				$selector.css('outline', '2px dotted red');
			}
		}
	}
}

function top(selector, conditional) {
	const $selector = $(selector);

	conditional = typeof conditional !== 'undefined' ? (typeof conditional === 'boolean' ? conditional : (parseFloat($(window).width()) >= conditional ? true : false)) : true;

	if ($selector.length) {
		$selector.css('height', 'auto'); // reset height

		if (conditional) {
			var offsetTop = 0;
			var height = 0;
			var uniqueHeights = [];
			var offsetHeights = [];

			// get
			$selector.each(function() {
				var thisOffset = $(this).offset().top;
				var thisHeight = parseFloat($(this).css('height'));

				if (s.transition) {
					// set initial to transition from
					$(this).css('height', thisHeight);

					// reset transition on resize event
					if ($(this).css('transition-property') == 'height') {
						$(this).css('transition', 'none');
					}

					// set transition
					if ($(this).css('transition-property') == 'all') {
						$(this).css('transition', 'height 0.2s');
					}
				}

				// check for greater offsetTop : reset then check for greater height
				height = thisOffset > offsetTop ? thisHeight : (thisHeight > height ? thisHeight : height);

				// check for greater offsetTop
				offsetTop = thisOffset > offsetTop ? thisOffset : offsetTop;

				uniqueHeights[offsetTop] = height;
			});

			// match
			$selector.each(function(index) {
				offsetHeights[index] = uniqueHeights[$(this).offset().top];
			});

			// set
			$selector.each(function(index) {
				$(this).css('height', offsetHeights[index]);

				// visual debug highlight equalized elements
				if (s.debug) {
					$(this).css('outline', '2px dotted red');
				}
			});
		}
	}
}

export {all, top};
